/**
 * 路由鉴权 透传事件
 */
import iview from 'view-design'
import store from '../store'
import { httpAxios } from '../views/home/serve/header'
import * as api  from '@/service'

let currentUrl = ''
const authGoNext = async url => {
  const me = this
  if (currentUrl === url) {
    return
  } else {
    currentUrl = url
  }
  const pramas = {
    uri: url
  }
  await api.queryChildResourcesByUri(pramas).then(res => {
      const result = res.data
      console.log('result==', result.data)
      const resourceT = store.state.user.resource
      if (result.code === '000000') {
        const jurObj = {}
        const data = result.data
        data.forEach(item => {
          jurObj[item.resourcesUri] = true
        })
        for (const key in jurObj) {
          let indexNum = 0
          for (const ikey in resourceT) {
            if (key === ikey) {
              resourceT[ikey] = jurObj[key]
              indexNum = indexNum + 1
            }
          }
          if (indexNum === 0) {
            resourceT[key] = jurObj[key]
          }
        }
        console.log('resource====', resourceT)
        console.log(
          '====存入vuex之前=====',
          resourceT['/workOrderSystem/classifyManagement/existing']
        )
        store.commit('SET_RESOURCE', resourceT)
      }else{
        iview.Message.error('TOKEN已失效')
        setTimeout(function () {
          httpAxios()
        },1000)
      }
    })
    .catch(err => {
      console.log('err==', err)
      iview.Message.error(err.response.data.description)
      setTimeout(function () {
        httpAxios()
      },1000)
    })
}
export default authGoNext
